import dataProvider from "src/dataProvider";

const fetcher = dataProvider("adminInstance");

export const checkKmlOverlap = (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  return fetcher.post<FormData, { overlaps: boolean }>(
    "/kml-master/check-overlap",
    formData,
    {},
    "v1",
    { "Content-Type": "multipart/form-data" }
  );
};
